<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.OFF-BrandCampaignEditPage {
    textarea {
        min-height: 100px;
    }

    h4 {
        margin: 40px 0 20px 0;
    }
}

/* Textarea auto-resize styles */
textarea-autosized,
.form-control textarea,
textarea.form-control {
    min-height: 100px;
    height: max-content;
    overflow-y: hidden;
    resize: vertical;
}

.custom-file-upload--disabled {
    display: none;
}

/* Image thumbnail wrapper */
.image-thumbnail-wrapper {
    transition: all 0.3s ease;
    position: relative;
    z-index: 1;
    
    &.clickable {
        cursor: pointer;
        
        &:hover {
            transform: scale(1.02);
            filter: brightness(0.95);
        }
        
        &:active {
            transform: scale(0.98);
        }
    }
    
    &.modal-open {
        pointer-events: none !important;
        cursor: default !important;
        z-index: 0 !important;
    }
}

/* Image modal styles */
.image-modal-overlay {
    animation: fadeIn 0.3s ease-in-out;
    backdrop-filter: blur(4px);
    pointer-events: auto;
    
    &.closing {
        animation: fadeOut 0.3s ease-in-out;
    }
}

.image-modal-content {
    animation: zoomIn 0.3s ease-in-out;
    
    .closing & {
        animation: zoomOut 0.3s ease-in-out;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
}

@keyframes zoomIn {
    from {
        opacity: 0;
        transform: scale(0.8);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

@keyframes zoomOut {
    from {
        opacity: 1;
        transform: scale(1);
    }
    to {
        opacity: 0;
        transform: scale(0.8);
    }
}
</style>

<template>
    <div class="page-content w-full max-w-4xl">
        <page-loader :loading="loading">
            <div class="p-none mb-10">
                <!-- Stories specific notice -->
                <div v-if="post_type === 'stories' && user_type === 'influencer'" class="p-4 mb-6">
                    <div class="flex items-center">
                        <p class="text-center text-black-600 text-[16px] line-height-[24px]">
                            Forbind dit content inden for 24 timer, efter du har postet, for at sikre, at brandet kan registrere dine data, inden din story forsvinder.
                        </p>
                    </div>
                </div>

                <!-- Always show JobContentStatus -->
                <div class="post-form">
                    <job-content-status :status="status" :user_type="user_type"></job-content-status>
                </div>

                <!-- Form fields - only show when shouldShowFormFields is true -->
                <form
                    v-if="shouldShowFormFields"
                    ref="form"
                    class="form-horizontal control-left"
                    @submit.prevent="update()"
                >
                    <div class="post-form">
                        <h3 style="margin-top: 40px;" v-if="getLabel(post_type, form_number)" :class="textColor">
                            {{ getLabel(post_type, form_number) }}
                        </h3>

                        <div class="flex flex-wrap">
                            <div class="w-full md:w-1/3">
                                <div v-if="is_media">
                                    <!-- Media: photo -->
                                    <form-item
                                        field="image"
                                        :form="form"
                                        help-block-class="col-sm-offset-4 col-sm-8"
                                    >
                                        <div class="col-sm-12 mb-4">
                                            <label class="control-label">Tilhørende billede</label>
                                            <p class="text-xs text-gray-700">
                                                Upload tilhørende billede eller video
                                            </p>
                                            <p v-if="form.image_url && (user_type === 'brand' || !isInfluencerShowButton)" class="text-xs text-gray-500 mt-2">
                                                Klik på billedet for at se det i fuld størrelse
                                            </p>
                                        </div>
                                        <div class="col-sm-12">
                                            <div 
                                                class="image-thumbnail-wrapper"
                                                :class="{ 
                                                    'clickable': form.image_url && !showImageModal && (user_type === 'brand' || !isInfluencerShowButton),
                                                    'modal-open': showImageModal
                                                }"
                                                @click="openImageModal(form.image_url)"
                                            >
                                                <image-input
                                                    :prefill="form.image_url"
                                                    width="250"
                                                    height="250"
                                                    @change="form.image = $event.file"
                                                    :disabled="user_type == 'brand' || !isInfluencerShowButton"
                                                >
                                                </image-input>
                                            </div>
                                        </div>
                                    </form-item>
                                </div>

                                <div v-if="post_type == 'videos' || post_type == 'sponsored' || post_type == 'reels' || post_type == 'posts' || post_type == 'stories' || post_type == 'shorts'">
                                    <!-- Media: video -->
                                    <div class="FormItem -ml-3">
                                        <div class="col-sm-12 mb-4">
                                            <label for="video_input" class="control-label">Tilhørende video</label>
                                            <p class="text-xs text-gray-700">
                                                Upload tilhørende video
                                            </p>
                                        </div>
                                        <div class="col-sm-12">
                                            <label for="video_input"
                                                class="custom-file-upload"
                                                :class="isInfluencerShowButton ? 'custom-file-upload--disabled' : ''"
                                                >
                                                <span v-if="!form.content['video_url']" class="w-full text-gray-400 font-semibold text-sm bg-white border file:cursor-pointer cursor-pointer file:border-0 file:py-3 file:px-4 file:mr-4 file:bg-gray-100 file:hover:bg-gray-200 file:text-gray-500 rounded py-3 px-4">No file uploaded</span>
                                            </label>
                                            <input
                                                v-if="user_type === 'influencer' && !isSubmitted && !isApproved"
                                                :style="user_type === 'brand' || !isInfluencerShowButton ? 'display: none;' : ''"
                                                id="video_input"
                                                :disabled="!isInfluencerShowButton"
                                                type="file"
                                                accept="video/*"
                                                class="w-full text-gray-400 font-semibold text-sm bg-white border file:cursor-pointer cursor-pointer file:border-0 file:py-3 file:px-4 file:mr-4 file:bg-gray-100 file:hover:bg-gray-200 file:text-gray-500 rounded"
                                                @change="handleVideoUpload($event)"
                                            />
                                            <p class="text-xs text-gray-400 mt-2">.mp4, .avi, .mov er tilladt. Filen må ikke overstige 200 MB.</p>
                                        </div>

                                        <div v-if="form.content['video_url']" class="col-sm-12 mt-3">
                                            <video :src="form.content['video_url']" controls class="w-full">
                                                Din browser understøtter ikke videoafspilning.
                                            </video>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="post_type == 'blog'">
                                    <div class="FormItem -ml-3">
                                        <div class="col-sm-12 mb-3">
                                            <label for="file_input" class="control-label mb-2" :class="textColor">Manuskript</label>
                                        </div>
                                        <div class="col-sm-12">
                                            <label for="file_input"
                                                class="custom-file-upload"
                                                :class="isInfluencerShowButton ? 'custom-file-upload--disabled' : ''"
                                                >
                                                <span v-if="!form.content['file_url']" class="w-full text-gray-400 font-semibold text-sm bg-white border file:cursor-pointer cursor-pointer file:border-0 file:py-3 file:px-4 file:mr-4 file:bg-gray-100 file:hover:bg-gray-200 file:text-gray-500 rounded py-3 px-4">No file uploaded</span>
                                            </label>
                                            <input
                                                v-if="user_type === 'influencer' && !isSubmitted && !isApproved"
                                                :style="user_type === 'brand' || !isInfluencerShowButton ? 'display: none;' : ''"
                                                id="file_input"
                                                :disabled="!isInfluencerShowButton"
                                                type="file"
                                                accept=".pdf, .doc, .docx"
                                                class="w-full text-gray-400 font-semibold text-sm bg-white border file:cursor-pointer cursor-pointer file:border-0 file:py-3 file:px-4 file:mr-4 file:bg-gray-100 file:hover:bg-gray-200 file:text-gray-500 rounded"
                                                @change="handleFileUpload($event)"
                                            />
                                            <p class="text-xs text-gray-400 mt-2">.pdf eller .doc, .docx er tilladt.</p>
                                        </div>

                                        <div v-if="form.content['file_url']" class="col-sm-12 mt-3">
                                            <a :href="form.content['file_url']" target="_blank" class="text-blue-500 underline">
                                                Se uploadet fil
                                            </a>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div v-if="post_type == 'live'" class="w-full">
                                <!-- Document upload -->
                                <div class="FormItem -ml-3">
                                    <div class="col-sm-12 mb-3">
                                        <label for="file_input" class="control-label mb-2" :class="textColor">Manuskript</label>
                                    </div>
                                    <div class="col-sm-12">
                                        <label for="file_input"
                                            class="custom-file-upload"
                                            :class="isInfluencerShowButton ? 'custom-file-upload--disabled' : ''"
                                            >
                                            <span v-if="!form.content['file_url']" class="w-full text-gray-400 font-semibold text-sm bg-white border file:cursor-pointer cursor-pointer file:border-0 file:py-3 file:px-4 file:mr-4 file:bg-gray-100 file:hover:bg-gray-200 file:text-gray-500 rounded py-3 px-4">No file uploaded</span>
                                        </label>
                                        <input
                                            :style="user_type === 'brand' || !isInfluencerShowButton ? 'display: none;' : ''"
                                            id="file_input"
                                            :disabled="!isInfluencerShowButton"
                                            type="file"
                                            accept=".pdf, .doc, .docx"
                                            class="w-full text-gray-400 font-semibold text-sm bg-white border file:cursor-pointer cursor-pointer file:border-0 file:py-3 file:px-4 file:mr-4 file:bg-gray-100 file:hover:bg-gray-200 file:text-gray-500 rounded"
                                            :class="{'border-red-500': validationErrors.file}"
                                            @change="handleFileUpload($event)"
                                        />
                                        <p class="text-xs text-gray-400 mt-2">.pdf eller .doc, .docx er tilladt.</p>
                                        <!-- Validation error messages -->
                                        <div v-if="validationErrors.file" class="mt-2">
                                            <p v-for="(error, index) in validationErrors.file"
                                            :key="index"
                                            class="text-red-500 text-sm">
                                                {{ error }}
                                            </p>
                                        </div>
                                    </div>

                                    <div v-if="form.content['file_url']" class="col-sm-12 mt-3">
                                        <a :href="form.content['file_url']" target="_blank" class="text-blue-500 underline">
                                            Se uploadet fil
                                        </a>
                                    </div>
                                </div>
                                <div v-if="isInfluencerShowFormButton" class="col-sm-8 flex justify-between items-center -ml-3 mt-4">
                                    <button
                                        class="btn btn-xl btn-load btn-success"
                                        :disabled="form.busy"
                                        @click="update('save')"
                                    >
                                        <span v-if="form.buttonText">{{ form.buttonText }}</span>
                                    </button>

                                    <button
                                        class="btn btn-xl btn-load btn-success"
                                        :disabled="form.busy"
                                        @click="update('submit')"
                                    >
                                        <span v-if="form.submitButtonText">{{ form.submitButtonText }}</span>
                                    </button>
                                </div>

                                <!-- Brand buttons for live posts -->
                                <div v-if="user_type === 'brand' && isSubmitted" class="col-sm-8 flex justify-between items-center -ml-3 mt-4">
                                    <button
                                        class="btn btn-xl btn-load btn-success"
                                        @click="approvePostContent()"
                                        :disabled="form.busy">
                                        <span v-if="form.approveButtonText">{{ form.approveButtonText }}</span>
                                    </button>
                                    <button
                                        class="btn btn-xl btn-load btn-success"
                                        @click="denyPostContent()"
                                        :disabled="form.busy">
                                        <span v-if="form.denyButtonText">{{ form.denyButtonText }}</span>
                                    </button>
                                </div>
                            </div>

                            <div class="w-full" v-bind:class="{'md:w-2/3':(post_type !== 'live')}">
                                <!-- Dynamic Fields -->
                                <div v-if="post_type != 'live' || user_type === 'brand'">
                                    <div v-for="field in fieldArray" :key="field.name">
                                        <form-item field="text" :form="form" help-block-class="col-sm-offset-4 col-sm-8">
                                            <div class="col-sm-4 md:text-right mb-3">
                                                <label class="control-label" :class="textColor">{{ field.label }}</label>
                                            </div>
                                            <div class="col-sm-8">
                                                <textarea-autosized
                                                    :key="`textarea-${textareaKey}-${field.name}`"
                                                    v-model="form.content[field.name]"
                                                    class="form-control"
                                                    :class="{'is-invalid': validationErrors[field.name]}"
                                                    :placeholder="field.placeholder"
                                                    :disabled="user_type === 'brand' || !isInfluencerShowButton"
                                                    :maxlength="field.maxlength"
                                                ></textarea-autosized>

                                                <!-- Validation error messages -->
                                                <div v-if="validationErrors[field.name]" class="invalid-feedback">
                                                    <div v-for="(error, index) in validationErrors[field.name]"
                                                        :key="index"
                                                        class="text-red-500 text-sm mt-1">
                                                        {{ error }}
                                                    </div>
                                                </div>
                                            </div>
                                        </form-item>
                                    </div>

                                    <div v-if="isInfluencerShowFormButton || (user_type === 'brand' && isSubmitted)" class="mt-10 form-group">
                                        <div v-if="isInfluencerShowFormButton" class="col-sm-4 md:text-right mb-3"></div>
                                        <div v-if="isInfluencerShowFormButton" class="col-sm-8 flex justify-between items-center">
                                            <button
                                                class="btn btn-xl btn-load btn-success"
                                                :disabled="form.busy"
                                                @click="update('save')"
                                            >
                                                <span>{{ form.buttonText }}</span>
                                            </button>

                                            <button
                                                class="btn btn-xl btn-load btn-success"
                                                :disabled="form.busy"
                                                @click="update('submit')"
                                            >
                                                <span>{{ form.submitButtonText }}</span>
                                            </button>
                                        </div>

                                        <!-- Brand buttons for main form (exclude live posts as they have their own buttons) -->
                                        <div v-if="user_type === 'brand' && isSubmitted && post_type !== 'live'" class="col-sm-4 md:text-right mb-3"></div>
                                        <div v-if="user_type === 'brand' && isSubmitted && post_type !== 'live'" class="col-sm-8 flex justify-between items-center">
                                            <button
                                                class="btn btn-xl btn-load btn-success"
                                                @click="approvePostContent()"
                                                :disabled="form.busy">
                                                <span v-if="form.approveButtonText">{{ form.approveButtonText }}</span>
                                            </button>
                                            <button
                                                class="btn btn-xl btn-load btn-success"
                                                @click="denyPostContent()"
                                                :disabled="form.busy">
                                                <span v-if="form.denyButtonText">{{ form.denyButtonText }}</span>
                                            </button>
                                        </div>
                                    </div>
                                    </div>

                                    <div v-if="user_type === 'influencer' && post_type === 'live'" class="col-sm-8 -ml-3 mt-6">
                                        <div class="px-4 py-3 rounded text-center font-light" style="background-color: #FFD4FD; color: #000000;">
                                            {{ warningMessage }}
                                        </div>
                                    </div>
                                    <div v-if="user_type === 'influencer' && post_type !== 'live'" class="mt-6 form-group">
                                        <div class="col-sm-4 md:text-right mb-3"></div>
                                        <div class="col-sm-8">
                                            <div class="px-4 py-3 rounded text-center font-light" style="background-color: #FFD4FD; color: #000000;">
                                                {{ warningMessage }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </form>

                <!-- Media attachment section (outside form) -->
                <div v-if="(user_type === 'influencer' && (isApproved || isSubmittedMedia || isDeniedMedia || isApprovedMedia)) || (user_type === 'brand' && (!isDeniedMedia))" class="w-full">
                    <div>
                        <attach-post-media :key="contentMediaKey" v-bind="{ job, post_type, form_number, status, user_type, media: contentMedia }"></attach-post-media>
                    </div>

                    <!-- Brand buttons for media -->
                    <div v-if="user_type === 'brand' && isSubmittedMedia" class="flex justify-center gap-4 mt-4">
                        <button
                            class="btn btn-xl btn-load btn-success"
                            @click="approvePostMedia()"
                            :disabled="form.busy">
                            <span v-if="form.approveButtonText">{{ form.approveButtonText }}</span>
                        </button>
                        <button
                            class="btn btn-xl btn-load btn-success"
                            @click="denyPostMedia()"
                            :disabled="form.busy">
                            <span v-if="form.denyButtonText">{{ form.denyButtonText }}</span>
                        </button>
                    </div>
                </div>

                <!-- Always show comment section -->
                <div class="mt-10" :class="shouldShowFormFields ? '' : 'w-full max-w-none'">
                    <div :class="shouldShowFormFields ? '' : 'bg-gray-50 p-6 rounded-lg'">
                        <job-comment-form
                            :post_type="post_type"
                            :job="job"
                            :user_type="user_type"
                            :editable="true"
                            :form_number="form_number">
                        </job-comment-form>
                    </div>
                </div>
            </div>
        </page-loader>

        <!-- Image Modal -->
        <div 
            v-if="showImageModal" 
            class="image-modal-overlay fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-90 p-6 pt-16 pb-6"
            :class="{ 'closing': isClosingModal }"
            @click="closeImageModal"
        >
            <button 
                @click.stop="closeImageModal"
                class="absolute top-[6rem] right-4 text-white bg-black bg-opacity-50 hover:bg-opacity-75 rounded-full w-12 h-12 flex items-center justify-center transition-all z-10 hover:scale-110"
                title="Luk (ESC)"
            >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
            <div class="image-modal-content relative w-full h-full max-w-[70vw] max-h-[75vh] flex items-center justify-center">
                <img 
                    :src="modalImageUrl" 
                    alt="Billede i fuld størrelse" 
                    class="max-w-full max-h-full w-auto h-auto object-contain rounded-lg shadow-2xl"
                    @click.stop
                />
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import HasLoadingState from 'dashboard-js/mixins/HasLoadingState'
import HasSubscriptions from 'dashboard-js/mixins/HasSubscriptions'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'
import JobContentStatus from './JobContentStatus.vue'
import TextareaAutosized from 'dashboard-js/components/utilities/TextareaAutosized'
export default {
    components: {
        JobContentStatus,
        TextareaAutosized
    },
    mixins: [RestoreOnPageBack, HasLoadingState, HasSubscriptions],
    props: ['editable', 'job', 'user_type', 'fields', 'form_number', 'post_type', 'is_media', 'is_file'],

    data() {
        // Initialize fieldArray by filtering and mapping the fields prop
        this.fieldArray = Object.keys(this.fields).filter(key => !isNaN(key)).map(key => this.fields[key])

        // Set textColor based on user_type
        this.textColor = ''
        if (this.user_type == 'brand') {
            this.textColor = '!text-black'
        }

        return {
            textColor: this.textColor,
            showHistory: false,
            form: new SparkForm({
                content: {},
            }),
            loading: true,
            status: null,
            contentMedia: null,
            contentMediaKey: 0,
            textareaKey: 0,
            validationRules: {
                required: true,
            },
            validationErrors: {},
            showImageModal: false,
            modalImageUrl: null,
            isClosingModal: false
        }
    },

    async created() {
        await this.load().then(() => this.loading = false)

        this.subscribe(Echo.private(`contents.${this.job.id}.${this.form_number+1}.${this.post_type}`)).listen(
            'Services\\Jobs\\Events\\ContentUpdated',
            () => {
                this.load(true)
            }
        )

        // Listen for tab change events
        Bus.$on('tabChanged', this.onTabChanged)

        // Add ESC key listener for closing modal
        document.addEventListener('keydown', this.handleEscKey)
    },

    beforeDestroy() {
        // Remove tab change listener
        Bus.$off('tabChanged', this.onTabChanged)
        
        // Remove ESC key listener when component is destroyed
        document.removeEventListener('keydown', this.handleEscKey)
        // Restore body scroll if modal was open
        document.body.style.overflow = ''
    },

    computed: {
        shouldShowContent() {
            if (this.user_type === 'influencer' && this.job.status !== 'declined' && this.job.status !== 'cancelled') {
                return true;
            }

            return (this.user_type === 'brand') && (this.isSubmitted || this.isApproved || this.isSubmittedMedia || this.isApprovedMedia || this.isDeniedMedia);
        },

        shouldShowFormFields() {
            // Influencers always see form fields when content is shown
            if (this.user_type === 'influencer') {
                return true;
            }
            
            // Brands only see form fields when there's actual content to review
            return (this.user_type === 'brand') && (this.isSubmitted || this.isApproved || this.isSubmittedMedia || this.isApprovedMedia || this.isDeniedMedia);
        },

        urls() {
            return this.job.content_urls
        },

        isSubmitted() {
            return this.status === 'submitted';
        },
        isSubmittedMedia() {
            return this.status === 'submitted_media';
        },

        isApproved() {
            return this.status === 'approved';
        },

        isDenied() {
            return this.status === 'denied';
        },

        isSaved() {
            return this.status === 'saved';
        },

        isApprovedMedia() {
            return this.status === 'approved_media';
        },

        isDeniedMedia() {
            return this.status === 'denied_media';
        },

        isInfluencerShowButton() {
            return this.user_type === 'influencer' && !this.isSubmitted && !this.isApproved && !this.isApprovedMedia && !this.isSubmittedMedia && !this.isDeniedMedia && !this.isJobFinished;
        },

        isInfluencerShowFormButton() {
            return this.user_type === 'influencer' && (this.isSaved || this.status === null || this.isDenied);
        },

        isJobFinished() {
            return this.job.status === 'finished';
        },

        warningMessage() {
            return 'ⓘ HUSK! Dit indhold skal være godkendt af virksomheden, INDEN du poster det på din profil';
        }
    },

    methods: {
        getStatusLabel(status) {
            switch(status) {
                case 'saved':
                    return 'Saved by Influencer';
                case 'submitted':
                    return 'Submitted by Influencer';
                case 'approved':
                    return 'Approved by Brand';
                case 'denied':
                    return 'Denied by Brand';
                case 'submitted_media':
                    return 'Media Submitted by Influencer';
                case 'approved_media':
                    return 'Media Approved by Brand';
                case 'denied_media':
                    return 'Media Denied by Brand';
                default:
                    return 'New';
            }
        },

        getStatusClass(status) {
            switch(status) {
                case 'saved':
                    return 'bg-gray-200 text-gray-800';
                case 'submitted':
                    return 'bg-blue-100 text-blue-800';
                case 'approved':
                    return 'bg-green-100 text-green-800';
                case 'denied':
                    return 'bg-red-100 text-red-800';
                case 'submitted_media':
                    return 'bg-purple-100 text-purple-800';
                case 'approved_media':
                    return 'bg-teal-100 text-teal-800';
                case 'denied_media':
                    return 'bg-orange-100 text-orange-800';
                default:
                    return 'bg-gray-100 text-gray-800';
            }
        },

        async load(silently) {
            await axios
                .get(route('api.job.content', [this.job.id, this.form_number+1, this.post_type]))
                .then(response => {
                    let content = {}

                    // Map the fetched data to the form content
                    content = Array.isArray(this.fieldArray) ? this.fieldArray.reduce((acc, field) => {
                        acc[field.name] = response.data.data['content'][field.name] || ''
                        return acc
                    }, {}) : {}

                    if (response.data.data['content']['file_url']) {
                        content['file_url'] = response.data.data['content']['file_url']
                    }

                    if (response.data.data['content']['video_url']) {
                        content['video_url'] = response.data.data['content']['video_url']
                    }

                    // Initialize the form with the fetched data
                    this.form = new SparkForm({
                        campaign_id: this.job.jobable.id,
                        job_id: response.data.job_id,
                        content: content,
                        post_type: this.post_type,
                        form_number: this.form_number,
                        image_url: response.data.data['image_url'] ? response.data.data['image_url'] : null,
                        buttonText: 'Gem indhold',
                        submitButtonText: 'Send indhold',
                        approveButtonText: 'Godkend indhold',
                        denyButtonText: 'Afvis indhold',
                    })

                    this.status = response.data.data['status']
                    this.contentMedia = response.data.data['content_media']
                    
                    // Increment key to force textarea re-render
                    this.textareaKey++
                })
                .then(this.finishLoading(silently))
                .then(this.saveState)
        },

        validateFileUpload() {
            const errors = [];

            // Check if a file has been uploaded
            if (!this.form.file && !this.form.content['file_url']) {
                errors.push('Du skal uploade et dokument');
            }

            return errors;
        },
        validateField(fieldName, value) {
            const errors = [];

            if (this.validationRules.required && !value?.trim()) {
                errors.push('Dette felt er påkrævet');
            }

            return errors;
        },

        validateForm() {
            this.validationErrors = {};
            let isValid = true;

            this.fieldArray.forEach(field => {
                const value = this.form.content[field.name];
                const fieldErrors = this.validateField(field.name, value);

                if (fieldErrors.length > 0) {
                    this.$set(this.validationErrors, field.name, fieldErrors);
                    isValid = false;
                }
            });

            if (this.post_type === 'live') {
                const fileErrors = this.validateFileUpload();
                if (fileErrors.length > 0) {
                    this.$set(this.validationErrors, 'file', fileErrors);
                    isValid = false;
                }
            }

            return isValid;
        },

        // Handle file upload for documents
        handleFileUpload(event) {
            this.validationErrors.file = [];
            this.handleMediaUpload(event, 'file')
        },

        // Handle file upload for videos
        handleVideoUpload(event) {
            this.handleMediaUpload(event, 'video')
        },

        // Generalized method to handle media uploads
        handleMediaUpload(event, type) {
            const file = event.target.files[0]
            this.$set(this.form, type, file)
        },

        // Update form data by sending it to the server
        update(action) {
            this.form.action = action

            if (!this.validateForm()) {
                // Show error message
                return;
            }
            if (action === 'save') {

                Spark.sendFormData(
                    'post',
                    route('api.job.action', [this.job.id, 'uploadPostContent']),
                    this.form
                ).then(response => {
                    this.form = new SparkForm(response.data)
                    this.$set(this.form, 'buttonText', 'Gemt!')
                    this.$set(this.form, 'submitButtonText', 'Send indhold')
                    this.$set(this.form, 'form_number', this.form_number)
                    this.status = 'saved'

                    setTimeout(() => {
                        this.$set(this.form, 'buttonText', 'Gem indhold')
                    }, 2000)
                })
            } else if (action === 'submit') {
                Spark.sendFormData(
                    'post',
                    route('api.job.action', [this.job.id, 'submitPostContent']),
                    this.form
                ).then(response => {
                    this.form = new SparkForm(response.data)
                    this.status = 'submitted'
                    this.$set(this.form, 'submitButtonText', 'Indsendt!')
                    this.$set(this.form, 'form_number', this.form_number)

                    setTimeout(() => {
                        this.$set(this.form, 'submitButtonText', 'Send indhold')
                    }, 2000)
                })
            }
        },

        approvePostContent() {
            Spark.post(route('api.job.action', [this.job.id, 'approvePostContent']), this.form).then(response => {
                if (response.error) {
                    this.error = response.error
                } else {
                    this.status = 'approved'
                }
            })
        },

        denyPostContent() {
            Spark.post(route('api.job.action', [this.job.id, 'denyPostContent']), this.form).then(response => {
                if (response.error) {
                    this.error = response.error
                } else {
                    this.status = 'denied'
                }
            })
        },

        approvePostMedia() {
            Spark.post(route('api.job.action', [this.job.id, 'approvePostMedia']), this.form).then(response => {
                if (response.error) {
                    this.error = response.error
                } else {
                    this.status = 'approved_media'
                }
            })
        },

        denyPostMedia() {
            Spark.post(route('api.job.action', [this.job.id, 'denyPostMedia']), this.form).then(response => {
                if (response.error) {
                    this.error = response.error
                } else {
                    this.status = 'denied_media'
                }
            })
        },

        getLabel(post_type, form_number) {
            const number = form_number + 1;
            switch (post_type) {
                case 'posts':
                    return `Post #${number}`;
                case 'stories':
                    return `Story #${number}`;
                case 'reels':
                    return `Reels #${number}`;
                case 'live':
                    return `Live #${number}`;
                case 'videos':
                    return `Video #${number}`;
                case 'sponsored':
                    return `Sponsor video #${number}`;
                case 'shorts':
                    return `Short #${number}`;
                case 'blog':
                    return `Blog #${number}`;
                default:
                    return;
            }
        },

        openImageModal(imageUrl) {
            // Only allow modal view when user cannot edit (brand or influencer with disabled state)
            if (imageUrl && (this.user_type === 'brand' || !this.isInfluencerShowButton)) {
                this.modalImageUrl = imageUrl;
                this.showImageModal = true;
                this.isClosingModal = false;
                // Prevent body scroll when modal is open
                document.body.style.overflow = 'hidden';
            }
        },

        closeImageModal() {
            // Add closing class for animation
            this.isClosingModal = true;
            
            // Wait for animation to complete before hiding
            setTimeout(() => {
                this.showImageModal = false;
                this.modalImageUrl = null;
                this.isClosingModal = false;
                // Restore body scroll
                document.body.style.overflow = '';
            }, 300); // Match animation duration
        },

        handleEscKey(event) {
            if (event.key === 'Escape' && this.showImageModal) {
                this.closeImageModal();
            }
        },

        onTabChanged() {
            // Force increment textareaKey to recreate textarea components when tab changes
            this.textareaKey++
        }
    },

    watch: {
        'form.content': {
            deep: true,
            handler() {
                this.validationErrors = {};
            }
        },
        'status': {
            handler(newStatus, oldStatus) {
                if (newStatus === 'approved_media' && oldStatus === 'submitted_media') {
                    Bus.$emit('approveContentMedia', { status: newStatus, postContent: this.form })
                }
            }
        }
    }
}
</script>
